import { NavigationConfig } from "../types";
import { isCRMRole, USER_ROLES } from "@/lib/constants/user-types";

/**
 * Derived flags computed once from the raw NavigationConfig. Each section
 * builder receives this so we avoid re-deriving role booleans throughout.
 */
export interface BuilderContext {
  config: NavigationConfig;
  featureFlags: Record<string, boolean>;
  userType: string;
  isAdmin: boolean;
  isCRM: boolean;
  isClientUser: boolean;
  isEmployee: boolean;
  /** Current user's email — for owner-only nav gates (e.g. Spend Intelligence). */
  userEmail?: string;
  /** Per-user sensitive-feature grants (SENSITIVE_FEATURES keys, e.g. "plaid"). */
  sensitiveFeatureAccess?: readonly string[] | null;
}

export function createBuilderContext(config: NavigationConfig): BuilderContext {
  const { userType, isAdmin, featureFlags, userEmail, sensitiveFeatureAccess } = config;
  return {
    config,
    featureFlags,
    userType,
    isAdmin,
    isCRM: isCRMRole(userType),
    isClientUser: userType === USER_ROLES.CLIENT_USER,
    isEmployee: userType === USER_ROLES.WTC_EMPLOYEE,
    userEmail,
    sensitiveFeatureAccess,
  };
}
